const FONT_LIST =
  "NanumSquareNeo, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Helvetica Neue', sans-serif";

export const baseTheme = {
  colors: {
    brand: [
      "#DCEFFF",
      "#B8DFFF",
      "#76C1FE",
      "#2FA1FE",
      "#017EE4",
      "#015AA1",
      "#01467F",
      "#013560",
      "#002442",
      "#00111E",
    ],
    excel: [
      "#E3F7EC",
      "#C8EFD9",
      "#8CDEB1",
      "#55CE8B",
      "#30A665",
      "#206F44",
      "#195735",
      "#134329",
      "#0D2C1B",
      "#07180E",
    ],
  },
  primaryColor: "brand",
  primaryShade: { light: 5, dark: 6 },

  colorScheme: "dark",
  fontFamily: FONT_LIST,
  fontFamilyMonospace:
    "JetBrainsMono, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
  headings: { fontFamily: FONT_LIST },
  cursorType: "pointer",
  // dateFormat: "YYYY-MM-DD", -> removed in 6.0
  // datesLocale: "ko", -> removed in 6.0

  components: {
    Button: {
      defaultProps: {
        variant: "filled",
        color: "brand",
      },
      sizes: {
        xxxs: () => ({
          root: {
            height: "1.25rem",
            padding: "0.3125rem",
            fontSize: "0.5rem",
          },
        }),
      },
    },
    Container: {
      defaultProps: {
        size: "lg",
        mb: "md",
        sizes: {
          xs: 540,
          sm: 720,
          md: 960,
          lg: 1440,
          xl: 1920,
        },
      },
    },
    Card: {
      defaultProps: {
        shadow: "md",
        radius: "md",
        withBorder: true,
      },
    },
    Table: {
      defaultProps: {
        verticalSpacing: "sm",
        striped: true,
        highlightOnHover: true,
      },
    },
    Group: {
      defaultProps: {
        position: "apart",
      },
    },
    Modal: {
      defaultProps: {
        centered: true,
        transitionProps: { transition: "pop-top-left" },
        // withinPortal: true,
        radius: "md",
      },
    },
    NumberInput: {
      defaultProps: {
        hideControls: true,
        mb: "xs",
        parser: (value) => value.replace(/\$\s?|(,*)/g, ""),
        formatter: (value) =>
          !Number.isNaN(parseFloat(value)) ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "",
      },
    },
    TextInput: {
      defaultProps: {
        mb: "xs",
      },
    },
    DatePickerInput: {
      defaultProps: {
        valueFormat: "YYYY.MM.DD",
        locale: "ko",
        popoverProps: {
          withinPortal: true,
        },
      },
    },
    DateInput: {
      defaultProps: {
        valueFormat: "YYYY.MM.DD",
        locale: "ko",
        popoverProps: {
          withinPortal: true,
        },
      },
    },
    MonthPickerInput: {
      defaultProps: {
        valueFormat: "YYYY년 MM월",
        locale: "ko",
        popoverProps: {
          withinPortal: true,
        },
      },
    },
    PasswordInput: {
      defaultProps: {
        mb: "xs",
      },
    },
    FileInput: {
      defaultProps: {
        mb: "xs",
      },
    },
    Select: {
      defaultProps: {
        withinPortal: true,
        mb: "xs",
      },
    },
    Badge: {
      defaultProps: {
        variant: "filled",
        radius: "sm",
      },
    },
  },
};
